import {
    PACKAGED_SOLUTION_QIDS,
    PROJECT_TEMPLATE_CODES,
    RAPID_SOLUTION_IDS,
    STATIC_STORAGE_URL
} from '@nexxt/common/constants';
import { NEW_PROJECT } from '../constants/routes';
import {
    PROJECT_STATUS,
    QUERY_TYPES as QUERY_TYPES_COMMON,
    QUOTA_STATUS,
    TENANT_LEVEL
} from '@nexxt/common/types';

export const PROJECT_SAVE_INTERVAL = 500;

export const mapping = {
    ACCOUNT_MANAGER: 'Account manager',
    PROJECT_MANAGER: 'Project manager'
};
export const status = [
    { value: 'ALL', label: 'All' },
    { value: PROJECT_STATUS.DRAFT, label: 'Draft' },
    { value: PROJECT_STATUS.PAUSED, label: 'Pause' },
    { value: PROJECT_STATUS.LIVE, label: 'Live' },
    { value: PROJECT_STATUS.COMPLETE, label: 'Complete' }
];

export const sort = [
    { value: 'LATEST', label: 'Latest' },
    { value: 'OLDEST', label: 'Oldest' }
];

export const rapidSolutionOrder = [
    RAPID_SOLUTION_IDS.RAPID_VIDEO_AD_TEST,
    RAPID_SOLUTION_IDS.RAPID_COPY_TEST,
    RAPID_SOLUTION_IDS.RAPID_IMAGE_TEST
];

export const packagedSolution = [
    {
        title: 'Build from Scratch',
        body: 'Build from inca’s suite of specialty qualitative and quantitative questions to meet your custom research needs.',
        image: `${STATIC_STORAGE_URL}/img/portal/packaged-solutions/build-from-scratch.png`,
        to: NEW_PROJECT,
        projectID: PACKAGED_SOLUTION_QIDS.BULID_FROM_SCRATCH,
        allowedTenantLevels: [TENANT_LEVEL.SANDBOX, TENANT_LEVEL.FULL_SERVICE],
        disabledTenantLevels: []
    },
    {
        title: 'Video Concept/Ad Test',
        subtitle: '',
        body: 'Craft video ads that resonate with inca’s specialty scene-by-scene annotation tool.',
        projectID: PACKAGED_SOLUTION_QIDS.VIDEO_AD,
        tenantID: process.env.PORTAL_TEMPLATE_TENANT, // @TODO: remove when possible
        image: `${STATIC_STORAGE_URL}/img/portal/packaged-solutions/video-creative-test.png`,
        allowedTenantLevels: [TENANT_LEVEL.SANDBOX, TENANT_LEVEL.FULL_SERVICE],
        disabledTenantLevels: []
    },
    {
        title: 'Rapid Video Ad Test Solution',
        subtitle: '',
        body: 'Craft video ads that resonate with inca’s specialty scene-by-scene annotation tool.',
        projectID: PACKAGED_SOLUTION_QIDS.RAPID_VIDEO_AD,
        rapidSolutionID: RAPID_SOLUTION_IDS.RAPID_VIDEO_AD_TEST,
        tenantID: -1, // @TODO: remove when possible
        image: `${STATIC_STORAGE_URL}/img/portal/packaged-solutions/video-creative-test.png`,
        codename: PROJECT_TEMPLATE_CODES.RAPID_VIDEO_AD_TEST,
        allowedTenantLevels: [TENANT_LEVEL.INCA_WIZARD],
        disabledTenantLevels: []
    },
    {
        title: 'Rapid Copy Test Solution',
        subtitle: '',
        body: 'Improve your copy with inca’s word-by-word, phrase-by-phrase feedback tool.',
        projectID: PACKAGED_SOLUTION_QIDS.RAPID_COPY_TEST,
        rapidSolutionID: RAPID_SOLUTION_IDS.RAPID_COPY_TEST,
        tenantID: -1, // @TODO: remove when possible
        image: `${STATIC_STORAGE_URL}/img/portal/packaged-solutions/video-creative-test.png`,
        codename: PROJECT_TEMPLATE_CODES.RAPID_COPY_TEST,
        allowedTenantLevels: [TENANT_LEVEL.INCA_WIZARD],
        disabledTenantLevels: []
    },
    {
        title: 'Rapid Image Ad Test Solution',
        subtitle: '',
        body: 'Craft OOH, banner and print ads that resonate with inca’s specialty hot spot feedback tool',
        projectID: PACKAGED_SOLUTION_QIDS.RAPID_IMAGE_TEST,
        rapidSolutionID: RAPID_SOLUTION_IDS.RAPID_IMAGE_TEST,
        tenantID: -1, // @TODO: remove when possible
        image: `${STATIC_STORAGE_URL}/img/portal/packaged-solutions/video-creative-test.png`,
        codename: PROJECT_TEMPLATE_CODES.RAPID_IMAGE_TEST,
        allowedTenantLevels: [TENANT_LEVEL.INCA_WIZARD],
        disabledTenantLevels: []
    },
    {
        title: 'Image Concept/Ad Test',
        subtitle: '',
        projectID: PACKAGED_SOLUTION_QIDS.IMAGE_AD,
        tenantID: process.env.PORTAL_TEMPLATE_TENANT,
        body: 'Craft OOH, banner and print ads that resonate with inca’s specialty hot spot feedback tool.',
        image: `${STATIC_STORAGE_URL}/img/portal/packaged-solutions/image-creative-test.png`,
        allowedTenantLevels: [TENANT_LEVEL.SANDBOX, TENANT_LEVEL.FULL_SERVICE],
        disabledTenantLevels: [TENANT_LEVEL.INCA_WIZARD]
    },
    {
        title: 'Copy Test',
        subtitle: '',
        projectID: PACKAGED_SOLUTION_QIDS.COPY_TEST, // @TODO: replace
        tenantID: process.env.PORTAL_TEMPLATE_TENANT, // @TODO: remove when possible
        body: 'Improve your copy with inca’s word-by-word, phrase-by-phrase feedback tool.',
        image: `${STATIC_STORAGE_URL}/img/portal/packaged-solutions/copy-test.png`,
        allowedTenantLevels: [TENANT_LEVEL.SANDBOX, TENANT_LEVEL.FULL_SERVICE],
        disabledTenantLevels: []
    },
    {
        title: 'Idea Test',
        subtitle: '',
        projectID: PACKAGED_SOLUTION_QIDS.IDEA_SCREENING, // @TODO: replace
        tenantID: process.env.PORTAL_TEMPLATE_TENANT, // @TODO: remove when possible
        body: 'Test ideas, features, logos, etc. and iterate fast using inca’s Tradeoff Ranking tool',
        image: `${STATIC_STORAGE_URL}/img/portal/packaged-solutions/idea-screening.png`,
        allowedTenantLevels: [
            TENANT_LEVEL.SANDBOX,
            TENANT_LEVEL.FULL_SERVICE,
            TENANT_LEVEL.INCA_WIZARD
        ],
        disabledTenantLevels: [TENANT_LEVEL.INCA_WIZARD]
    },
    {
        title: 'Brand Understanding',
        subtitle: '',
        body: 'Understand System 1 or System 2 types of connections and emotions associated with your brand at scale',
        projectID: PACKAGED_SOLUTION_QIDS.BRAND_TEST,
        tenantID: process.env.PORTAL_TEMPLATE_TENANT, // @TODO: remove when possible
        image: `${STATIC_STORAGE_URL}/img/portal/packaged-solutions/brand-test.png`,
        allowedTenantLevels: [TENANT_LEVEL.SANDBOX, TENANT_LEVEL.FULL_SERVICE],
        disabledTenantLevels: []
    },
    {
        title: 'CX Understanding',
        subtitle: '',
        body: 'Understand how your customers interact with and experience your brand and how to build engagement and advocacy',
        projectID: PACKAGED_SOLUTION_QIDS.CX_TEST,
        tenantID: process.env.PORTAL_TEMPLATE_TENANT, // @TODO: remove when possible
        image: `${STATIC_STORAGE_URL}/img/portal/packaged-solutions/cx-test.png`,
        allowedTenantLevels: [TENANT_LEVEL.SANDBOX, TENANT_LEVEL.FULL_SERVICE],
        disabledTenantLevels: []
    },
    {
        title: 'Path-to-Purchase',
        subtitle: '',
        projectID: null, // @TODO: replace
        tenantID: null, // @TODO: remove when possible
        body: 'Map and size customer purchase paths with inca’s specialty journey mapping tool.',
        image: `${STATIC_STORAGE_URL}/img/portal/packaged-solutions/path-to-purchase.png`,
        allowedTenantLevels: [],
        disabledTenantLevels: [
            TENANT_LEVEL.SANDBOX,
            TENANT_LEVEL.FULL_SERVICE,
            TENANT_LEVEL.INCA_WIZARD
        ]
    },
    {
        title: 'RBC Video Ad Evaluation',
        subtitle: '',
        body: 'Get a go/no-go indicator and rich scene-by-scene feedback to fine-tune your video ads. This template is well suited for any video, including early stage board-a-matics, rough cuts, and finished ads. [VIDEOS UP TO 1 MINUTE AND 200MB ACCEPTED.]',
        tenantID: process.env.PORTAL_TEMPLATE_TENANT,
        projectID: PACKAGED_SOLUTION_QIDS.RBC_VIDEO_AD,
        image: `${STATIC_STORAGE_URL}/img/portal/packaged-solutions/video-creative-test.png`,
        allowedTenantLevels: [TENANT_LEVEL.SELF_SERVICE],
        disabledTenantLevels: []
    },
    {
        title: 'RBC Script Test',
        subtitle: '',
        body: 'Improve your copy with inca’s word-by-word, phrase-by-phrase feedback tool.',
        tenantID: process.env.PORTAL_TEMPLATE_TENANT,
        projectID: PACKAGED_SOLUTION_QIDS.RBC_COPY_TEST,
        image: `${STATIC_STORAGE_URL}/img/portal/packaged-solutions/copy-test.png`,
        allowedTenantLevels: [TENANT_LEVEL.SELF_SERVICE],
        disabledTenantLevels: []
    }
];
export const QUERY_TYPE = {
    ...QUERY_TYPES_COMMON,
    MODAL_OPEN: 'modal',
    CUSTOM_SCREENER: 'custom_screener'
};

export const REDIRECTS_MAPPING = [
    { type: QUOTA_STATUS.COMPLETE },
    { type: QUOTA_STATUS.TERMINATE },
    { type: QUOTA_STATUS.QUOTA_FULL },
    { type: QUOTA_STATUS.SECURITY }
];
export const REDIRECT_LABEL = {
    [QUOTA_STATUS.COMPLETE]: 'Completion',
    [QUOTA_STATUS.TERMINATE]: 'Termination',
    [QUOTA_STATUS.QUOTA_FULL]: 'Quota Full',
    [QUOTA_STATUS.SECURITY]: 'Security Disqualification'
};
